import { ERROR_ACTION, SET_PHYSICAL_TEST_DATA, SET_MEDICAL_TEST_DATA } from "../../common/constants/ActionTypes";

const initialState = {
  errorMessage: "",
  physicalTestData: [],
  medicalTestData: [],
};

export default function testsReducer(state = initialState, action) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case SET_PHYSICAL_TEST_DATA:
      return {
        ...state,
        physicalTestData: action.payload,
      };
    case SET_MEDICAL_TEST_DATA:
      return {
        ...state,
        medicalTestData: action.payload,
      };

    default:
      return state;
  }
}
